var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('loader',{attrs:{"loading":_vm.loading}}),(_vm.settingsEndpoint)?_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('mailbox-settings',{attrs:{"endpoint":_vm.settingsEndpoint}})],1)]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }